/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IGrupoActividadEconomica from 'Infotrack@Modelos/administracion/grupoActividadEconomica/entidades/grupoActividadEconomica';
import React from 'react';
import GrupoActividadEconomicaCM from '../controladorModelo/grupoActividadEconomicaCM';
import { acciones, IEstadoGrupoActividadEconomica } from '../reductorGrupoActividadEconomica';
import FormularioGrupoActividadEconomicaVista from '../vista/formularioGrupoActividadEconomicaVista';

const estadoInicial: IGrupoActividadEconomica = {
    CodigoGrupoActividadEconomica: '',
    NombreGrupoActividadEconomica: '',
    EstadoGrupoActividadEconomica: true,
};
const grupoActividadEconomicaCM = new GrupoActividadEconomicaCM();

const FormularioGrupoActividadEconomicaCV: React.FunctionComponent = () => {
    const [{ estadoFormulario, tipoFormulario, entidadGrupoActividadEconomica }, dispatch] = useProveedor<
        IEstadoGrupoActividadEconomica
    >();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IGrupoActividadEconomica>(estadoInicial);

    React.useEffect(() => {
        if (entidadGrupoActividadEconomica && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadGrupoActividadEconomica);
        } else {
            reiniciar();
        }
    }, [entidadGrupoActividadEconomica]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionGrupoActividadEconomica = () => {
        if (grupoActividadEconomicaCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarGrupoActividadEconomica,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarGrupoActividadEconomica = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            grupoActividadEconomicaCM.crearGrupoActividadEconomica(valor).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA });
            });
        } else {
            grupoActividadEconomicaCM.editarGrupoActividadEconomica(valor).then(() => {
                cerrarFormulario();
                manejadorIndicadorCargaGlobal(false);
                dispatch({ type: acciones.RECARGAR_TABLA });
            });
        }
    };

    return (
        <FormularioGrupoActividadEconomicaVista
            accionCrearEditar={confirmarCreacionEdicionGrupoActividadEconomica}
            cambiarInfoFomulario={alCambiarValor}
            grupoActividadEconomica={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

export default FormularioGrupoActividadEconomicaCV;
